import { useAppStateContext } from '@/shared';
import { defaultLoggerApi } from '../apis';
import * as Sentry from '@sentry/react';
import { version } from '../../../../package.json';

export const useLogger = () => {
  const { appState } = useAppStateContext();
  const screenInfo = appState.screenInfo;

  const LogError = (type, errorInfo) => {
    try {
      const screenLog = screenInfo
        ? `Version : ${version} |Location : ${screenInfo.locationId} | Screen :${screenInfo.screenId} | Group : ${screenInfo.groupId} | Info : `
        : '';

      const logInfo = screenLog.concat(errorInfo);
      defaultLoggerApi({ type, logInfo });
    } catch (error) {
      console.error(error);
    }
  };

  const LogInformation = (info) => {
    Sentry.captureMessage(info, 'info');
  };

  const LogToExternal = (type, data) => {
    switch (type) {
      case 'error': {
        Sentry.captureException(data);
        break;
      }
      case 'info':
        LogInformation(data);
        break;
      default:
        console.error('Invalid type');
        break;
    }
  };
  return { LogError, LogInformation, LogToExternal };
};
